import { Link } from "react-router-dom";
import Faq from "../Sections/home/Faq";
import Logos from "../Sections/home/Logos";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCircle } from "@fortawesome/free-regular-svg-icons";
import { faTelegram } from "@fortawesome/free-brands-svg-icons";
import { ContactReq, useGetFaqQuery, useGetSettingQuery, useSendContactMutation } from "../Redux/Apis/authApi";
import { useState } from "react";
import { toast } from "react-toastify";
import MetaTags from "../Components/MetaTags";

function Contact() {
    const {data: faqData, isSuccess} = useGetFaqQuery()
    const {data: settingsData} = useGetSettingQuery()
    const [sendContact,{isLoading}] = useSendContactMutation()
    const [errorMsg, setErrorMsg] = useState<any>(false)

    const [formState, setFormState] = useState<ContactReq>({
        name:"",
        subject:"",
        email:"",
        body:"",
    })

    const defaultAboutUs = `<h6>🔻 هدف ما همواره در GREhub این بوده که با مناسب‌ترین قیمت ها، امکان مسلط شدن و تمرین سوالات اصلی آزمون GRE را برای شما داوطلبان عزیز در محیط شبیه ساز آزمون فراهم آوریم، تا بیش از یک بار نخواهید هزینه 220 دلاری آزمون را پرداخت نمایید و به راحتی در همان بار اول، نمره مورد نظر خودتان را بدست آورید.</h6>
                        <h6>✅ به همین منظور در کنار محیط شبیه ساز آزمون که خدمت اصلی ماست، تمامی منابع اصلی آزمون GRE را به طور رایگان در این مقاله و یا سایر منابع اصلی از جمله دوره های پرمیوم گرگمت را در کانال تلگرام GREhub VIP به طور کاملا رایگان در اختیار شما عزیزان قرار داده ایم.</h6>
                        <h6>🔻 با وجود هزینه های دلاری سایت به خاطر ادیتور حرفه ای Froala (قیمت اشتراک Enterprise را خودتان ببینید😉) به جهت وارد کردن فرمول های ریاضی که امکانش در حالت عادی طراحی سایت نیست </h6>
                        <h6>(سایر شبیه سازها مثل تافل، آیلتس و ...، فرمولی ندارند، و در نتیجه چنین هزینه ای هم ندارند!)</h6>
                        <h6>🔻 اما ما باز سعی نمودیم با مناسب ترین مبلغ ها، امکان آزمون دادن را برای شما عزیزان فراهم آوریم، و در حالی که می توانستیم مانند برخی موسسات به اسم ماک تافل، ماک آیلتس، برای هر تک آزمون، آن هم سوالات شبیه آزمون، نه خود سوالات اصلی آزمون! ووچر در نظر بگیرم و عددهای نجومی طلب کنیم</h6>
                        <h6>✅ اما چون بر خلاف هدف ما که ارائه با قیمت مناسب، به همه داوطلبان عزیز بود، این طور عمل نکردیم</h6>
                        <h6>✅ به طوری که هم اکنون شما می توانید با کمتر از 3% هزینه یک آزمون اصلی GRE، به بیش از 180 آزمون اصلی و ماک دسترسی داشته باشید!</h6>
                        <h6>✅ و با این سرمایه گذاری روی خود، شانس موفقیت در همان اولین آزمون GRE که می دهید را چندین برابر کنید. </h6>
                        <h6>برای اطلاع از آخرین آپدیت ها و برترین منابع آزمون GRE، در شبکه های اجتماعی به خصوص کانال تلگرامی GREhub همراه ما باشید.</h6>`;
    const aboutUsHtml = settingsData?.about_us ?? defaultAboutUs;
    const address = settingsData?.address ?? "Q9Q9+74X Dist 2, Tehran";

    const handleChange = ({ target: { name, value },} : React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement> ) =>
        setFormState((prev) => ({ ...prev, [name]: value }))

    const onSubmit = async (e : React.FormEvent) => {
        e.preventDefault()
        try {
            const exam = await sendContact(formState).unwrap()
            if (exam) toast.success('پیام شما با موفقیت ارسال گردید');
            setFormState({
                name:"",
                subject:"",
                email:"",
                body:""
            })
            setErrorMsg(false) 
        } catch (err:any){
            console.log(err);
            const message = !err.data ? '' : Array.isArray(err.data.message) ? err.data.message[0] : err.data.message
            setErrorMsg(message)                                     
        }
    }

    return ( 
        <>
        <MetaTags
            siteName="سایت مرجع آزمون GRE"
            title="درباره ما | سایت مرجع آزمون GRE"
            description="سایت GREhub شبیه ساز حرفه ای آزمون های بین المللی GRE با این هدف راه اندازی شده است که شما داوطلبان گرامی بتوانید سوالات واقعی آزمون GRE، مثل کراون Crown، دالائو Dalao و سایر سوالات اصلی را در محیط شبیه ساز آزمون به صورت آنلاین تمرین کنید، تا مدیریت زمان را به خوبی فراگرفته، و در نتیجه در سنتر و موقع آزمون اصلی بهترین نمره را به راحتی بدست آورید و سپس از دانشگاه های مورد نظرتان به آسانی پذیرش بگیرید."
            url="https://grehub.org/contact"
            image="https://grehub.org/GREhub_LOGO.jpg"
            ogType="website"
            twitterCard="summary_large_image"
        />
        <div className="container-fluid bg-danger py-2 bg-header mb-5" style={{marginBottom: "90px"}}>
            <div className="row py-5">
                <div className="col-12 pt-lg-5 mt-lg-5 text-center">
                    <h1 className="display-4 text-white animated zoomIn">درباره ما</h1>
                    <Link to="/" className="h5 text-white">خانه</Link>
                    <FontAwesomeIcon icon={faCircle} className="text-white px-2"/>
                    <Link to="/contact" className="h5 text-white">درباره ما</Link>
                </div>
            </div>
        </div>

        <div className="container-fluid wow fadeInUp" data-wow-delay="0.1s">
            <div className="container py-2">
                <div className="section-title text-center position-relative pb-3 mb-4 mx-auto mt-0" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger">درباره GREHub</h5>
                    {/* <h3 className="mb-0"></h3> */}
                </div>
                <div className="row mb-5 aboutus">
                    <div className="col-12">
                        <div dangerouslySetInnerHTML={{__html: aboutUsHtml}} />
                    </div>
                </div>
                <div className="section-title text-center position-relative pb-3 mb-4 mx-auto mt-0" style={{maxWidth: "600px"}}>
                    <h5 className="fw-bold text-danger">راه های ارتباط با GREHub</h5>
                    {/* <h3 className="mb-0"></h3> */}
                </div>
                <div className="row g-5 mb-5">
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.1s">
                            <div className="bg-danger d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon={faTelegram} className="text-white"></FontAwesomeIcon>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">پشتیبانی تلگرام</h5>
                                <a href="https://t.me/GREhub" className="text-danger mb-0 h4">t.me/GREhub</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.4s">
                            <div className="bg-danger d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon="envelope-open" className="text-white"></FontAwesomeIcon>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">پست الکترونیک</h5>
                                <a href="mailto:info@grehub.org" className="text-danger mb-0 h4">info@grehub.org</a>
                            </div>
                        </div>
                    </div>
                    <div className="col-lg-4">
                        <div className="d-flex align-items-center wow fadeIn" data-wow-delay="0.8s">
                            <div className="bg-danger d-flex align-items-center justify-content-center rounded" style={{width: "60px", height: "60px"}}>
                                <FontAwesomeIcon icon="map-marker-alt" className="text-white"></FontAwesomeIcon>
                            </div>
                            <div className="ps-4">
                                <h5 className="mb-2">آدرس دفتر</h5>
                                <h4 className="text-danger mb-0">{address}</h4>
                            </div>
                        </div>
                    </div>
                </div>
                <div className="row g-5">
                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.3s">
                        <form onSubmit={onSubmit}>
                            <div className="row g-3">
                                <div className="col-md-6">
                                    <input type="text" name="name" onChange={handleChange} value={formState.name} className="form-control border-0 bg-light px-4" placeholder="نام" style={{height: "55px"}}/>
                                </div>
                                <div className="col-md-6">
                                    <input type="email" name="email" onChange={handleChange} value={formState.email} className="form-control border-0 bg-light px-4" placeholder="ایمیل" style={{height: "55px"}}/>
                                </div>
                                <div className="col-12">
                                    <input type="text" name="subject" onChange={handleChange} value={formState.subject} className="form-control border-0 bg-light px-4" placeholder="موضوع" style={{height: "55px"}}/>
                                </div>
                                <div className="col-12">
                                    <textarea name="body" onChange={handleChange} value={formState.body} className="form-control border-0 bg-light px-4 py-3" rows={4} placeholder="متن پیام"></textarea>
                                </div>
                                <div className="col-12">
                                    <button className="btn btn-danger w-100 py-3" disabled={isLoading} type="submit">ارسال پیام</button>
                                </div>
                                {errorMsg && <div className="alert alert-danger" role="alert">
                                    {errorMsg}
                                </div>}
                            </div>
                        </form>
                    </div>
                    <div className="col-lg-6 wow slideInUp" data-wow-delay="0.6s">
                        
                        <iframe title="map" className="position-relative rounded w-100 h-100"
                            src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3236.4763471035117!2d51.3678594!3d35.7882375!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x3f8e077643665f71%3A0xaf28a2749202cc1b!2sQ9Q9%2B74X%20District%202%2C%20Tehran%2C%20Tehran%20Province!5e0!3m2!1sen!2s!4v1733682430610!5m2!1sen!2s" 
                            style={{minHeight: "350px", border:"0"}} allowFullScreen={true} aria-hidden="false" loading="lazy" 
                            referrerPolicy="no-referrer-when-downgrade" tabIndex={0}>
                        </iframe>
                    </div>
                </div>
            </div>
        </div>

        {isSuccess && faqData && <Faq data={faqData}/>}
        <Logos />
        </>
     );
}

export default Contact;
